import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { authAPI } from '../services/api';

const VerifyEmail = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');
  const hasAttempted = useRef(false);

  useEffect(() => {
    const verifyEmail = async () => {
      // Prevent double execution (React StrictMode calls useEffect twice)
      if (hasAttempted.current) return;
      hasAttempted.current = true;

      try {
        const response = await authAPI.verifyEmail(token);
        setStatus('success');
        setMessage(response.message);
      } catch (error) {
        setStatus('error');
        setMessage(
          error.response?.data?.detail ||
          'Verification failed. The link may be invalid or expired.'
        );
      }
    };

    if (token) {
      verifyEmail();
    } else {
      setStatus('error');
      setMessage('Invalid verification link.');
    }
  }, [token]);

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-5">
            <div className="card card-static shadow-lg">
              <div className="card-body p-5 text-center">
                {status === 'verifying' && (
                  <>
                    <div className="spinner-border text-primary mb-4" role="status">
                      <span className="visually-hidden">Verifying...</span>
                    </div>
                    <h2 className="h4 mb-3">Verifying Your Email</h2>
                    <p className="text-muted">Please wait while we verify your email address...</p>
                  </>
                )}

                {status === 'success' && (
                  <>
                    <div className="mb-4">
                      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" className="text-success" viewBox="0 0 16 16">
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                      </svg>
                    </div>
                    <h2 className="h4 mb-3 text-success">Email Verified!</h2>
                    <p className="text-muted mb-4">{message}</p>
                    <button
                      className="btn btn-primary"
                      onClick={() => navigate('/login')}
                    >
                      Continue to Login
                    </button>
                  </>
                )}

                {status === 'error' && (
                  <>
                    <div className="mb-4">
                      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" className="text-danger" viewBox="0 0 16 16">
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
                      </svg>
                    </div>
                    <h2 className="h4 mb-3 text-danger">Verification Failed</h2>
                    <p className="text-muted mb-4">{message}</p>
                    <div className="d-flex gap-2 justify-content-center">
                      <button
                        className="btn btn-outline-primary"
                        onClick={() => navigate('/login')}
                      >
                        Go to Login
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
